export default "#define GLSLIFY 1\nuniform vec2 uCursor;\n\nvarying vec3 vNormal;\n\nvoid main(){\n    gl_FragColor = vec4(vNormal,1.0);\n}";